import { array, bool, func, object, string } from 'prop-types';
import LoadingBackdrop from 'components/LoadingBackdrop';
import Tabs from './Tabs';
import Roles from './Roles';
import MenuModal from './MenuModal';
import { ArrowBottom, ArrowRight } from 'components/icons';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import sty from '../styles/TableList.module.css';
import useTableList from '../hooks/useTableList';

/**
 * @component TableList
 * @param { Object } props
 * @param { boolean } props.open
 * @param { object } props.savingState
 * @param { object } props.savingHandler
 * @param { string } props.groupId
 * @param { array } props.selectedTabs
 * @param { array } props.selectedRoles
 * @param { array } props.roles
 * @param { array } props.tabs
 * @param { function } props.onMenu
 * @returns { JSX.Element }
 */
function TableList(props) {
	const tab = useTableList(props.savingState, props.savingHandler);
	const role = useTableList(props.savingState, props.savingHandler);

	return (
		<Collapse in={props.open} timeout="auto" unmountOnExit>
			<section className={sty.section}>
				<IconButton onClick={tab.onToggle}>
					{tab.open ? <ArrowBottom /> : <ArrowRight />}
				</IconButton>
				<InputBase value="Tabs" />
			</section>
			<Tabs
				open={tab.open}
				trgRst={tab.trgRst}
				savingState={props.savingState}
				savingHandler={props.savingHandler}
				groupId={props.groupId}
				selectedTabs={props.selectedTabs}
				tabs={props.tabs}
				onMenu={props.onMenu}
			/>
			{tab.modal && <MenuModal open={tab.modal} onClose={tab.onClose} onSave={tab.onSave} />}
			<section className={sty.section}>
				<IconButton onClick={role.onToggle}>
					{role.open ? <ArrowBottom /> : <ArrowRight />}
				</IconButton>
				<InputBase value="Roles" />
			</section>
			<Roles
				open={role.open}
				trgRst={role.trgRst}
				state={props.savingState}
				handler={props.savingHandler}
				groupId={props.groupId}
				selectedRoles={props.selectedRoles}
				roles={props.roles}
				onMenu={props.onMenu}
			/>
			{role.modal && <MenuModal open={role.modal} onClose={role.onClose} onSave={role.onSave} />}
			<LoadingBackdrop open={props.savingState.loading} />
		</Collapse>
	);
}

TableList.propTypes = {
	open: bool,
	savingState: object,
	savingHandler: object,
	groupId: string,
	selectedTabs: array,
	selectedRoles: array,
	roles: array,
	tabs: array,
	onMenu: func,
};

export default TableList;
